import React from "react";
import mail from "../../assets/images/mail_icon.webp";
import call from "../../assets/images/call_icon.webp";
import location from "../../assets/images/location_icon.webp";
import ticket from "../../assets/images/customer-icon.webp";
import { Link } from "react-router-dom";
const Contact = () => {
  const handleWhatsAppClick = () => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-667242866/rungCOCk-IUYEMnKwpAp",
      });
    }
  };

  return (
    <>
      <section className="row_am contact_page_section">
        <div className="container">
          <div className="contact_inner">
            <div className="row">
              <div className="col-lg-6">
                <div className="contact_info">
                  <div className="section_title">
                    <h3>Contact informations</h3>
                    <p>Get in touch with us.</p>
                  </div>
                  <ul className="contact_info_list">
                    <li>
                      <div className="img">
                        <img src={mail} alt="image" />
                      </div>
                      <div className="text">
                        <span>Email Us</span>
                        <Link href="mailto:minalabel88@gmail.com">
                          minalabel88@gmail.com
                        </Link>
                      </div>
                    </li>
                    <li>
                      <div className="img">
                        <img src={call} alt="image" />
                      </div>
                      <div className="text">
                        <span>Our Whatsapp</span>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Link
                            to="https://api.whatsapp.com/send?phone=6282188883321&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven."
                            style={{ display: "block" }}
                            onClick={handleWhatsAppClick}
                          >
                            +62 821 8888 3321
                          </Link>
                          <Link
                            to="https://api.whatsapp.com/send?phone=6282180004827&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven."
                            style={{ display: "block" }}
                            onClick={handleWhatsAppClick}
                          >
                            +62 821 8000 4827
                          </Link>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="img">
                        <img src={location} alt="image" />
                      </div>
                      <div className="text">
                        <span>Visit Us</span>
                        <p>
                          Jembatan Besi VI No.7 RT/RW 01/03 Kecamatan Tambora,
                          Jakarta Barat​
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="contact_info">
                  <div className="ticket_box">
                    <div className="pattern-rotate">
                      <img src="images/pattern-rotate1.webp" alt="image" />
                    </div>
                    <div className="icon">
                      <img src={ticket} alt="image" />
                    </div>
                    <div className="section_title">
                      <h3>Contact Via Whatsapp</h3>
                      <p>
                        Butuh bantuan cepat? Hubungi kami langsung melalui
                        Whatsapp.
                      </p>
                    </div>
                    <Link
                      to="https://api.whatsapp.com/send?phone=6282188883321&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven."
                      className="btn puprple_btn"
                      onClick={handleWhatsAppClick}
                    >
                      Hubungi Kami
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Contact;
